import React from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import List from './ListCourses';
import { useTranslation } from 'react-i18next';

const CoursesList = () => {
    const { t } = useTranslation();
    document.title = t("courses_list.title");

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("courses_list.breadcrumb_title")} pageTitle={t("courses_list.breadcrumb_page_title")} />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default CoursesList;